/* eslint-disable no-shadow */
// import Immutable from 'seamless-immutable';
import createReducer from '../../helpers/createReducer';
import {
  swiper as state
} from '../store';

export default createReducer(state, {
  SET_DONE_MATERIAL: (state, { data: doneMaterials }) => ({
    ...state,
    doneMaterials: [...state.doneMaterials, doneMaterials]
    // doneMaterials: {
    //   ...state.doneMaterials,
    //   [level]: [...state.doneMaterials[level], doneMaterials]
    // }
  }),
  REMOVE_DONE_MATERIAL: (state, { data: numOfQuestions }) => ({
    ...state,
    doneMaterials: state.doneMaterials.splice(0, state.doneMaterials.length - numOfQuestions)
  }),
  SET_SWIPER_LEVEL: (state, { data: currentLevel }) => ({
    ...state,
    currentLevel
  })
});
